module.exports = __webpack_public_path__ + "img/11.e83b91c4.jpg";